module.exports = __webpack_public_path__ + "static/media/key-icon-light.56ad7431.svg";